import { Container } from "./style";
import Post from "./post";

function Posts({ posts }) {
  return (
    <Container>{posts && posts?.map((post) => <Post post={post} />)}</Container>
  );
}
export default Posts;
